import React, {useEffect, useState} from 'react';
import Modal from '../../../../../components-new/ui/Modal';
import {getCategories, getConversationInfo, saveConversationInfo} from '../../../../../services/company/api';
import config from '../../../../../config';
import {addNotification as addNotificationAction} from "../../../../../services/notification/action";
import {connect} from "react-redux";
import {generalModalStyles} from "../../../../../utils/General";
import {endConversationForOperatorRequested} from "../../../../../services/chat/action";
import Input from "../../../../../components-new/form/Input";
import Translate, {t} from "../../../../../components/Translate";
import SilverButton from "../../../../../components-new/buttons/SilverButton";
import BlueButton from "../../../../../components-new/buttons/BlueButton";
import DropdownSelect from "../../../../../components-new/form/DropdownSelect";
import Field from "../../../../../components-new/form/Field";
import PowerIcon from "../../../../../assets/icons/PowerIcon";
import SilentModeSwitch from "./SilentModeSwitch";
import './ChatActionModals.css';

const EndConversationModal = ({
                                  isOpen,
                                  cancelAction,
                                  conversation,
                                  user,
                                  endConversationForOperator,
                                  addNotification,
                                  features
                              }) => {
    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [subject, setSubject] = useState('');
    const [description, setDescription] = useState('');
    const [priority, setPriority] = useState('');
    const [silentMode, setSilentMode] = useState(false);
    const [inProcess, setInProcess] = useState(false);
    const [isTicket, setIsTicket] = useState(false);
    const [assignee, setAssignee] = useState('');
    const [categoryOptions, setCategoryOptions] = useState([]);

    useEffect(() => {
        if (isOpen && conversation) {
            (async () => {
                const conv = await getConversationInfo(conversation.id);
                const cats = await getCategories(conversation.companyId);

                setCategories(cats);

                const options = [
                    {label: t({text: 'withoutCategory', user}), value: ''}
                ];
                cats.map(c => {
                    options.push({label: c.name, value: c.id});
                })

                setCategoryOptions(options);

                setSelectedCategory(options.find(o => o.value == conv.categoryId) || options[0]);

                setSubject(conv.subject || '');
                setDescription(conv.description || '');
                setPriority(conv.priority || '');
                setInProcess(conv.inProcess || false);
                setIsTicket(conv.ticket || false);
                setAssignee(conv.assignedUser ? conv.assignedUser.platformId : '');
            })();
        }
    }, [isOpen, conversation, user]);

    const handleSaveAndEnd = () => {
        saveConversationInfo(
            selectedCategory.value, // here need category id
            subject,
            description,
            priority,
            inProcess,
            isTicket,
            conversation.id,
            assignee
        )
            .then(() => addNotification('convInfoCreated/Updated', config.notificationLevels.success))
            .catch(() => addNotification('somethingWentWrong', config.notificationLevels.error));

        let details = {
            category: selectedCategory.value === '' ? '' : selectedCategory.label, //here need category name
            subject: subject,
            description: description
        }
        endConversationForOperator(silentMode, conversation, details);
        cancelAction();
    };

    return (
        <Modal isOpen={isOpen} style={generalModalStyles.convHeaderModalStyles}
               onRequestClose={cancelAction}
               title={<Translate text="endConversation"/>}
               description={<Translate text="endConversationModalDescription"/>}
               headerIcon={<PowerIcon width={20} height={20} stroke="var(--ds-fg-secondary)"/>}
               headerSeparator
               footerSeparator
               footer={<React.Fragment>
                   <SilverButton type="button" width="auto" height="40px" onClick={cancelAction}>
                       <Translate text="close"/>
                   </SilverButton>
                   <BlueButton type="button" width="auto" height="40px" onClick={handleSaveAndEnd}>
                       <Translate text="saveAndEnd"/>
                   </BlueButton>
               </React.Fragment>}>
            <div className="chat-action-modal__body">
            {features.includes(config.features.CATEGORIES) && (
                <Field label="category">
                    <DropdownSelect selectedValue={selectedCategory} options={categoryOptions}
                                    onChange={e => setSelectedCategory(e)} styles={{width: '100%', height: '40px'}}/>
                </Field>
            )}

            <Input label={<Translate text="subject"/>} value={subject} maxLength={150} type="text"
                   name="subject" style={{height: '40px'}} onChange={e => setSubject(e.target.value)}/>

            <Input label={<Translate text="description"/>} isTextarea style={{minHeight: '160px'}}
                   value={description} resize="none" maxLength={5000} name="description"
                   onChange={e => setDescription(e.target.value)}/>

            <SilentModeSwitch
                checked={silentMode}
                onChange={setSilentMode}
                hint="silentModeEndHint"
            />
            </div>
        </Modal>
    );
};

const mapDispatchToProps = dispatch => ({
    addNotification: (message, level, config) => {
        dispatch(addNotificationAction(message, level, config));
    },
    endConversationForOperator: (silentMode, conv, details) => {
        dispatch(endConversationForOperatorRequested(silentMode, conv, details));
    },
});

export default connect(null, mapDispatchToProps)(EndConversationModal);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/chat/chat-components/EndConversationModal.jsx